import { useEffect, useId, useRef, useState } from "react";
import { Button } from "@/components/ui/button";

export function MoreMenu({ items, procurement = false }: { procurement?: boolean; items: { label: string; onClick: () => void }[] }) {
  const [open, setOpen] = useState(false);
  const root = useRef<HTMLDivElement>(null);
  const id = useId();
  const close = (restoreFocus = true) => {
    setOpen(false);
    if (restoreFocus) root.current?.querySelector<HTMLButtonElement>("button")?.focus();
  };
  useEffect(() => {
    if (!open) return;
    root.current?.querySelector<HTMLButtonElement>('[role="menuitem"]')?.focus();
    const outside = (event: PointerEvent) => {
      if (event.target instanceof Node && !root.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener("pointerdown", outside);
    return () => document.removeEventListener("pointerdown", outside);
  }, [open]);
  if (!items.length) return null;
  return <div className={procurement ? "procurement-more" : "relative"} ref={root} onBlur={event => {
    if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false);
  }} onKeyDown={event => {
    if (event.key === "Escape" && open) { event.preventDefault(); close(); }
    if (event.key === "Tab") setOpen(false);
  }}>
    <Button className={procurement ? undefined : "min-h-11"} variant="secondary" aria-haspopup="menu" aria-expanded={open} aria-controls={open ? id : undefined}
      onClick={() => setOpen(value => !value)} onKeyDown={event => {
        if (["ArrowDown", "ArrowUp"].includes(event.key)) { event.preventDefault(); setOpen(true); }
      }}>Više <span aria-hidden="true">▾</span></Button>
    {open && <div id={id} role="menu" aria-label="Više radnji" className={procurement ? "procurement-more-menu" : "absolute right-0 top-full z-30 mt-2 w-[min(320px,calc(100vw-2rem))] rounded-xl border border-[var(--color-border)] bg-[var(--color-card)] p-2 shadow-lg"} onKeyDown={event => {
      const buttons = Array.from(event.currentTarget.querySelectorAll<HTMLButtonElement>('[role="menuitem"]'));
      const index = buttons.indexOf(document.activeElement as HTMLButtonElement);
      let next: number;
      if (event.key === "ArrowDown") next = (index + 1) % buttons.length;
      else if (event.key === "ArrowUp") next = (index - 1 + buttons.length) % buttons.length;
      else if (event.key === "Home") next = 0;
      else if (event.key === "End") next = buttons.length - 1;
      else return;
      event.preventDefault(); buttons[next]?.focus();
    }}>{items.map(item => <button key={item.label} className={procurement ? undefined : "block min-h-11 w-full rounded-lg px-3 py-2 text-left whitespace-normal hover:bg-[var(--color-muted)] focus-visible:bg-[var(--color-muted)]"} type="button" role="menuitem" tabIndex={-1}
      onClick={() => { close(); item.onClick(); }}>{item.label}</button>)}</div>}
  </div>;
}
